module.exports = __webpack_public_path__ + "static/img/beijing.cfe8d6ee66.png";